/**
 * Phone digits as the E.164 number the zeus PhoneNumber scalar takes: a bare
 * 10-digit US number (or 11 with the leading 1) gains the +1 prefix; a
 * +-prefixed number passes through. Undefined for anything else.
 */
export const e164UsPhone = (phone: string): string | undefined => {
  const trimmed = phone.trim();
  if (/^\+\d{10,15}$/.test(trimmed)) {
    return trimmed;
  }
  if (/^\d{10}$/.test(trimmed)) {
    return `+1${trimmed}`;
  }
  if (/^1\d{10}$/.test(trimmed)) {
    return `+${trimmed}`;
  }
  return undefined;
};
